import { C } from "../constants";
import { Sec, STitle, Step } from "../components/Shared";

export default function HowItWorks() {
  return (
    <div>
      <Sec>
        <STitle tag="How It Works" title="Getting started with SafeZapp" sub="From download to supervised messaging in just a few minutes" />

        <div style={{ maxWidth: 680, margin: "0 auto" }}>
          <h3 style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800, fontSize: 20, color: C.blueDark, marginBottom: 28 }}>
            For Approvers (Trusted Adults)
          </h3>
          <Step num="1" title="Download & Register" desc="Download SafeZapp from the App Store or Google Play and create your account. Select 'I am an Approver' during registration and accept the privacy policy." color={C.blueLight} />
          <Step num="2" title="Generate a Pairing Code" desc="From your dashboard, generate a unique 6-digit pairing code. This code is valid for 15 minutes and can only be used once. Share it with the person you're linking in person — this ensures real-world coordination." color={C.yellowLight} />
          <Step num="3" title="Confirm the Link" desc="When the user enters your code, you'll receive a link request. Confirm their age bracket (under 13, 13–17, or 18+) and declare your relationship (guardian, carer, trusted person, etc.)." color={C.accentLight} />
          <Step num="4" title="You're in Control" desc="Once linked, you can manage their approved contacts and review new contact requests — all from your approver dashboard." color={C.blueLight} />

          <div style={{ borderTop: `1px solid ${C.border}`, margin: "40px 0", paddingTop: 40 }}>
            <h3 style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800, fontSize: 20, color: C.blueDark, marginBottom: 28 }}>
              For Users
            </h3>
            <Step num="1" title="Download & Register" desc="Download SafeZapp from the App Store or Google Play and create your account. Select 'I need an Approver' during registration." color={C.blueLight} />
            <Step num="2" title="Enter the Pairing Code" desc="Your approver will give you a 6-digit code. Enter it in the app to send them a link request." color={C.yellowLight} />
            <Step num="3" title="Wait for Approval" desc="Your approver will confirm the link. Until they do, your account is in a waiting state — no messaging is possible yet." color={C.accentLight} />
            <Step num="4" title="Start Chatting Safely" desc="Once linked, you can message approved contacts. SafeZapp's AI checks messages in the background — if something isn't kind, it'll suggest a better way to say it." color={C.blueLight} />
          </div>

          <div style={{
            background: C.yellowLight, borderRadius: 14, padding: "20px 24px",
            border: "1px solid rgba(255,215,0,0.3)", marginTop: 12
          }}>
            <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: 14.5, color: C.text, margin: 0, lineHeight: 1.7 }}>
              <strong>What if no approver links?</strong> If a user's account isn't linked to an approver within 14 days, SafeZapp automatically and permanently deletes all associated data. No orphaned accounts, no lingering data.
            </p>
          </div>
        </div>
      </Sec>
    </div>
  );
}
